import client from './client';
import qs from 'qs';

/**
 * 품절 배치 관리 - 리스트
 */
export const SoldOutList = (param) =>
  client.get(`/api/manage/soldout/list`, param);

/**
 * 품절 배치 관리 - 수정용
 */
export const SoldOutEditView = (adverId) =>
  client.get(`/api/manage/soldout/view?` + qs.stringify(adverId));

/**
 * 품절 배치 관리 - 등록
 */
export const SoldOutWrite = (title, domains) =>
  client.post(`/api/manage/soldout/key_write`, qs.stringify(title, domains));

/**
 * 품절 배치 관리 - 수정
 */
export const SoldOutKeyEdit = (title, domains) =>
  client.post(`/api/manage/soldout/key_edit`, qs.stringify(title, domains));

/**
 * 품절 배치 관리 - 품절사용여부, 품절구분 수정
 */
export const SoldOutEdit = (params) =>
  client.post(`/api/manage/soldout/edit`, qs.stringify(params));
